import React, { Component, RefObject } from 'react';
import ldUniqBy from 'lodash/uniqBy';
import Textbox from '../../../component/atoms/Textbox';
import Checkbox from '../../../component/atoms/Checkbox';
import { Icon } from '@material-ui/core';
import { Link } from 'react-router-dom';
import Dropdown from '../../../component/atoms/Dropdown';
import { FilterItem, FilterState } from '../../../redux/reducers/StoreFilterReducer';

import { getFilteredNodeList, initialization, changeNode } from './function';
import _ from 'lodash';
import { AgencyInfo } from '../../../redux/reducers/StoreSelectorReducer';
import { formatTargetStores } from '../StoreFilterEmployee/function';
import { getDuplicateStoreIndexes } from '../../../utils/StoreFilterList';

export interface StoreSelectModalProps {
  stores: AgencyInfo[];
  filterStore: FilterState;
  updateDraftStore: (item: FilterItem) => void;
  itemActive: FilterItem;
  errorMessageHeight: number;
  groupAgencies: { [key: string]: AgencyInfo[] };
  originalAgencies: {
    [key: string]: AgencyInfo;
  };
}

export interface booleanMap {
  [key: string]: boolean;
}

export interface checkedMap {
  [key: string]: boolean | undefined;
}

export interface NodeInfo {
  index: string;
  code: string;
  name: string;
  isActive: boolean;
}

export interface StoreSelectModalState {
  anchorEl: HTMLElement | null;
  searchValue: string;
  //画面に表示されている部門１一覧
  displayedOnAreaDept1List: NodeInfo[];
  isAreaDept1Checked: checkedMap;
  //画面に表示されている部門２一覧
  displayedOnAreaDept2List: NodeInfo[];
  isAreaDept2Checked: checkedMap;
  //画面に表示されている部門３一覧
  displayedOnAreaDept3List: NodeInfo[];
  isAreaDept3Checked: checkedMap;
  //画面に表示されている部門４一覧
  displayedOnAreaDept4List: NodeInfo[];
  isAreaDept4Checked: checkedMap;
  //画面に表示されている部門５一覧
  displayedOnAreaDept5List: NodeInfo[];
  isAreaDept5Checked: checkedMap;
  //画面に表示されている取次店一覧
  displayedOnAgencyList: NodeInfo[];
  isStoreChecked: booleanMap;
}

export default class extends Component<StoreSelectModalProps, StoreSelectModalState> {
  private inputRef: RefObject<HTMLInputElement>;

  constructor(props: StoreSelectModalProps) {
    super(props);

    this.state = {
      anchorEl: null,
      searchValue: '',
      displayedOnAreaDept1List: [],
      isAreaDept1Checked: {},
      displayedOnAreaDept2List: [],
      isAreaDept2Checked: {},
      displayedOnAreaDept3List: [],
      isAreaDept3Checked: {},
      displayedOnAreaDept4List: [],
      isAreaDept4Checked: {},
      displayedOnAreaDept5List: [],
      isAreaDept5Checked: {},
      displayedOnAgencyList: [],
      isStoreChecked: {},
    };

    this.inputRef = React.createRef<HTMLInputElement>();
    this.changeTargetStoresOnareadept = this.changeTargetStoresOnareadept.bind(this);
    this.changeActiveareadept = this.changeActiveareadept.bind(this);
  }

  /**
   * チェックボックスの状態が変わり、検索対象部門の数を再計算して
   * propsのtargetStoresをupdateする
   */
  changeTargetStoresOnareadept(index: string, floorNum: number) {
    const { stores, groupAgencies, originalAgencies } = this.props;
    const newState: StoreSelectModalState = { ...this.state };
    const selectedStoreIndexes = index.split(',');
    const duplicateStoreIndexes: string[] = getDuplicateStoreIndexes(selectedStoreIndexes, originalAgencies, groupAgencies);

    //STEP2 チェックボックスの状態の取得
    selectedStoreIndexes.forEach(() => {
      switch (floorNum) {
        case 1: {
          duplicateStoreIndexes.forEach((subIndex: string) => {
            newState.isStoreChecked[subIndex] = !newState.isAreaDept1Checked[index];
          });
          break;
        }
        case 2: {
          duplicateStoreIndexes.forEach((subIndex: string) => {
            newState.isStoreChecked[subIndex] = !newState.isAreaDept2Checked[index];
          });
          break;
        }
        case 3: {
          duplicateStoreIndexes.forEach((subIndex: string) => {
            newState.isStoreChecked[subIndex] = !newState.isAreaDept3Checked[index];
          });
          break;
        }
        case 4: {
          duplicateStoreIndexes.forEach((subIndex: string) => {
            newState.isStoreChecked[subIndex] = !newState.isAreaDept4Checked[index];
          });
          break;
        }
        case 5: {
          duplicateStoreIndexes.forEach((subIndex: string) => {
            newState.isStoreChecked[subIndex] = !newState.isAreaDept5Checked[index];
          });
          break;
        }
        case 6: {
          duplicateStoreIndexes.forEach((subIndex: string) => {
            newState.isStoreChecked[subIndex] = !newState.isStoreChecked[subIndex];
          });
          break;
        }
      }
    });

    changeNode(stores, newState);

    const targetStores = formatTargetStores(stores, newState.isStoreChecked);

    this.props.updateDraftStore({
      ...this.props.itemActive,
      ordcstmCdList: targetStores,
    });

    this.setState({
      isAreaDept1Checked: newState.isAreaDept1Checked,
      isAreaDept2Checked: newState.isAreaDept2Checked,
      isAreaDept3Checked: newState.isAreaDept3Checked,
      isAreaDept4Checked: newState.isAreaDept4Checked,
      isAreaDept5Checked: newState.isAreaDept5Checked,
      isStoreChecked: newState.isStoreChecked,
    });
  }

  /**
   * 画面に表示されている一次代理店配下の部門情報を、
   * クリックされた一次代理店配下の情報に更新する
   * @param index
   * @param floorNum
   */
  changeActiveareadept(index: string, floorNum: number) {
    const newState: StoreSelectModalState = { ...this.state };
    const { stores } = this.props;

    initialization(stores, newState, index, floorNum);

    this.setState({
      displayedOnAreaDept1List: newState.displayedOnAreaDept1List,
      displayedOnAreaDept2List: newState.displayedOnAreaDept2List,
      displayedOnAreaDept3List: newState.displayedOnAreaDept3List,
      displayedOnAreaDept4List: newState.displayedOnAreaDept4List,
      displayedOnAreaDept5List: newState.displayedOnAreaDept5List,
      displayedOnAgencyList: newState.displayedOnAgencyList,
    });
  }

  /**
   * 一部選択状態を判定する
   */
  isIndeterminateByIndex(index: string): boolean {
    const { isStoreChecked } = this.state;

    const allIsTrue = index.split(',').every((i) => isStoreChecked[i] === true);

    if (allIsTrue) {
      return false;
    }
    return true;
  }

  /**
   * propsの部門リストをモーダル用のStateに展開する
   * @param prevProps 更新前のprops
   */

  componentDidUpdate(prevProps: Readonly<StoreSelectModalProps>): void {
    /**
     * 新しいフィルタが追加されるたびに、[新規フィルタ] ボタンをクリックすると、新しいフィールドに値 NEW_FILTER_ID が filterID に渡されます。
     * したがって、新しいフィルターを追加するたびにフィルターを区別するために、filterUuid フィールドを追加する必要があります。
     */
    if (
      this.props.itemActive.filterID !== prevProps.itemActive.filterID ||
      this.props.itemActive.filterUuid !== prevProps.itemActive.filterUuid
    ) {
      this.renderWithActiveFilterStore();
    }
  }

  componentDidMount(): void {
    this.renderWithActiveFilterStore();
  }

  renderWithActiveFilterStore = () => {
    const newState: StoreSelectModalState = { ...this.state };
    const { stores } = this.props;
    initialization(stores, newState, '', 0);

    //STEP2 チェックボックスの状態の取得
    //一旦全部未選択状態にする
    stores.forEach((obj, i) => {
      if (this.props.itemActive.ordcstmCdList.includes(obj.agencyCd)) {
        newState.isStoreChecked[i] = true;
      } else {
        newState.isStoreChecked[i] = false;
      }
    });

    changeNode(stores, newState);

    this.setState({
      displayedOnAreaDept1List: newState.displayedOnAreaDept1List,
      isAreaDept1Checked: newState.isAreaDept1Checked,
      displayedOnAreaDept2List: newState.displayedOnAreaDept2List,
      isAreaDept2Checked: newState.isAreaDept2Checked,
      displayedOnAreaDept3List: newState.displayedOnAreaDept3List,
      isAreaDept3Checked: newState.isAreaDept3Checked,
      displayedOnAreaDept4List: newState.displayedOnAreaDept4List,
      isAreaDept4Checked: newState.isAreaDept4Checked,
      displayedOnAreaDept5List: newState.displayedOnAreaDept5List,
      isAreaDept5Checked: newState.isAreaDept5Checked,
      displayedOnAgencyList: newState.displayedOnAgencyList,
      isStoreChecked: newState.isStoreChecked,
    });
  };

  // 検索結果ドロップダウン
  renderSuggestion() {
    const { stores } = this.props;

    return (
      <div className='' style={{ width: 720, maxWidth: '100%' }}>
        <Textbox
          data-testid-e2e='filterStoreSelectModal-searchTextBox'
          data-testid='filterStoreSearchTextBox'
          inputRef={this.inputRef}
          leftIcon='search'
          wrapperClass='filter-modal__textbox u-w-full'
          value={this.state.searchValue}
          placeholder='店舗名で検索'
          onChange={(e) => this.setState({ searchValue: e.target.value })}
        />
        {/* 検索結果リスト */}
        <ul className='list'>
          <li
            data-testid='filterStoresearchareadept1Title'
            data-testid-e2e='filterStoreSelectModal-searchareadept1Title'
            className='filter-modal__header-title'>
            部門1 ({_.map(this.state.isAreaDept1Checked, (data) => data).filter((a) => a).length}
            件)
          </li>
          {getFilteredNodeList(stores, this.state.searchValue, 1) &&
            getFilteredNodeList(stores, this.state.searchValue, 1).map((nodeInfo) => (
              <li
                key={nodeInfo.code}
                className='list__item-link list__item-link--has-left-icon'
                data-testid='filterStoreSearchareadept1Result'
                data-testid-e2e='filterStoreSelectModal-searchareadept1Result'>
                <Checkbox
                  className='list__left-checkbox'
                  name='example-checkbox'
                  aria-label={nodeInfo.name}
                  onChange={() => {
                    this.changeTargetStoresOnareadept(nodeInfo.index, 1);
                  }}
                  checked={this.state.isAreaDept1Checked[nodeInfo.index]}
                  isIndeterminate={this.isIndeterminateByIndex(nodeInfo.index)}
                  value={nodeInfo.code}
                />
                <Link
                  aria-label={`dd1-${nodeInfo.name}`}
                  to='#'
                  onClick={() => {
                    this.changeTargetStoresOnareadept(nodeInfo.index, 1);
                  }}>
                  {nodeInfo.name}
                </Link>
              </li>
            ))}
          <li
            data-testid='filterStoreSearchareadept2Title'
            data-testid-e2e='filterStoreSelectModal-searchareadept2Title'
            className='filter-modal__header-title'>
            部門2 ({_.map(this.state.isAreaDept2Checked, (data) => data).filter((a) => a).length}
            件)
          </li>
          {getFilteredNodeList(stores, this.state.searchValue, 2) &&
            getFilteredNodeList(stores, this.state.searchValue, 2).map((nodeInfo) => (
              <li
                key={nodeInfo.code}
                className='list__item-link list__item-link--has-left-icon'
                data-testid='filterStoreSearchareadept2Result'
                data-testid-e2e='filterStoreSelectModal-searchareadept2Result'>
                <Checkbox
                  className='list__left-checkbox'
                  name='example-checkbox'
                  aria-label={nodeInfo.name}
                  onChange={() => {
                    this.changeTargetStoresOnareadept(nodeInfo.index, 2);
                  }}
                  checked={this.state.isAreaDept2Checked[nodeInfo.index]}
                  isIndeterminate={this.isIndeterminateByIndex(nodeInfo.index)}
                  value={nodeInfo.code}
                />
                <Link
                  to='#'
                  aria-label={`dd2-${nodeInfo.name}`}
                  onClick={() => {
                    this.changeTargetStoresOnareadept(nodeInfo.index, 2);
                  }}>
                  {nodeInfo.name}
                </Link>
              </li>
            ))}
          <li
            data-testid='filterStoreSearchareadept3Title'
            data-testid-e2e='filterStoreSelectModal-searchareadept3Title'
            className='filter-modal__header-title'>
            部門3 ({_.map(this.state.isAreaDept3Checked, (data) => data).filter((a) => a).length}
            件)
          </li>
          {getFilteredNodeList(stores, this.state.searchValue, 3) &&
            getFilteredNodeList(stores, this.state.searchValue, 3).map((nodeInfo) => (
              <li
                key={nodeInfo.code}
                className='list__item-link list__item-link--has-left-icon'
                data-testid='filterStoreSearchareadept3Result'
                data-testid-e2e='filterStoreSelectModal-searchareadept3Result'>
                <Checkbox
                  className='list__left-checkbox'
                  name='example-checkbox'
                  aria-label={nodeInfo.name}
                  onChange={() => {
                    this.changeTargetStoresOnareadept(nodeInfo.index, 3);
                  }}
                  checked={this.state.isAreaDept3Checked[nodeInfo.index]}
                  isIndeterminate={this.isIndeterminateByIndex(nodeInfo.index)}
                  value={nodeInfo.code}
                />
                <Link
                  to='#'
                  aria-label={`dd3-${nodeInfo.name}`}
                  onClick={() => {
                    this.changeTargetStoresOnareadept(nodeInfo.index, 3);
                  }}>
                  {nodeInfo.name}
                </Link>
              </li>
            ))}
          <li
            data-testid='filterStoresearchareadept4Title'
            data-testid-e2e='filterStoreSelectModal-searchareadept4Title'
            className='filter-modal__header-title'>
            部門4 ({_.map(this.state.isAreaDept4Checked, (data) => data).filter((a) => a).length}
            件)
          </li>
          {getFilteredNodeList(stores, this.state.searchValue, 4) &&
            getFilteredNodeList(stores, this.state.searchValue, 4).map((nodeInfo) => (
              <li
                key={nodeInfo.code}
                className='list__item-link list__item-link--has-left-icon'
                data-testid='filterStoreSearchareadept4Result'
                data-testid-e2e='filterStoreSelectModal-searchareadept4Result'>
                <Checkbox
                  className='list__left-checkbox'
                  name='example-checkbox'
                  aria-label={nodeInfo.name}
                  onChange={() => {
                    this.changeTargetStoresOnareadept(nodeInfo.index, 4);
                  }}
                  checked={this.state.isAreaDept4Checked[nodeInfo.index]}
                  isIndeterminate={this.isIndeterminateByIndex(nodeInfo.index)}
                  value={nodeInfo.code}
                />
                <Link
                  to='#'
                  aria-label={`dd4-${nodeInfo.name}`}
                  onClick={() => {
                    this.changeTargetStoresOnareadept(nodeInfo.index, 4);
                  }}>
                  {nodeInfo.name}
                </Link>
              </li>
            ))}
          <li
            data-testid='filterStoreSearchareadept5Title'
            data-testid-e2e='filterStoreSelectModal-searchareadept5Title'
            className='filter-modal__header-title'>
            部門5 ({_.map(this.state.isAreaDept5Checked, (data) => data).filter((a) => a).length}
            件)
          </li>
          {getFilteredNodeList(stores, this.state.searchValue, 5) &&
            getFilteredNodeList(stores, this.state.searchValue, 5).map((nodeInfo) => (
              <li
                key={nodeInfo.code}
                className='list__item-link list__item-link--has-left-icon'
                data-testid='filterStoreSearchareadept5Result'
                data-testid-e2e='filterStoreSelectModal-searchareadept5Result'>
                <Checkbox
                  className='list__left-checkbox'
                  name='example-checkbox'
                  aria-label={nodeInfo.name}
                  onChange={() => {
                    this.changeTargetStoresOnareadept(nodeInfo.index, 5);
                  }}
                  checked={this.state.isAreaDept5Checked[nodeInfo.index]}
                  isIndeterminate={this.isIndeterminateByIndex(nodeInfo.index)}
                  value={nodeInfo.code}
                />
                <Link
                  to='#'
                  aria-label={`dd5-${nodeInfo.name}`}
                  onClick={() => {
                    this.changeTargetStoresOnareadept(nodeInfo.index, 5);
                  }}>
                  {nodeInfo.name}
                </Link>
              </li>
            ))}
          <li
            data-testid='filterStoreSearchAgencyStoreTitle'
            data-testid-e2e='filterStoreSelectModal-searchAgencyStoreTitle'
            className='filter-modal__header-title'>
            店舗 ({_.map(this.state.isStoreChecked, (data) => data).filter((a) => a).length}
            件)
          </li>
          {getFilteredNodeList(stores, this.state.searchValue, 6) &&
            ldUniqBy(getFilteredNodeList(stores, this.state.searchValue, 6), 'code').map((nodeInfo, idx) => (
              <li
                key={`${nodeInfo.code}-${idx}`}
                className='list__item-link list__item-link--has-left-icon'
                data-testid='filterStoreSearchAgencyStoreResult'
                data-testid-e2e='filterStoreSelectModal-searchAgencyStoreResult'>
                <Checkbox
                  className='list__left-checkbox'
                  name='example-checkbox'
                  aria-label={nodeInfo.name}
                  onChange={() => {
                    this.changeTargetStoresOnareadept(nodeInfo.index, 6);
                  }}
                  checked={this.state.isStoreChecked[nodeInfo.index]}
                  isIndeterminate={this.isIndeterminateByIndex(nodeInfo.index)}
                  value={nodeInfo.code}
                />
                <Link
                  to='#'
                  aria-label={`dd6-${nodeInfo.name}`}
                  onClick={() => {
                    this.changeTargetStoresOnareadept(nodeInfo.index, 6);
                  }}>
                  {nodeInfo.name}
                </Link>
              </li>
            ))}
        </ul>
      </div>
    );
  }

  onCloseWithEscapeKeyDown(e: React.KeyboardEvent<HTMLDivElement>) {
    if (e.key === 'Escape') {
      this.setState({ anchorEl: null });
    }
  }

  render() {
    const { anchorEl, searchValue } = this.state;
    const { errorMessageHeight } = this.props;

    return (
      <>
        <div style={{ position: 'relative', borderTop: '1px solid rgb(227, 223, 223)' }}>
          <Dropdown
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            popover={this.renderSuggestion()}
            onKeyDown={(e) => this.onCloseWithEscapeKeyDown(e)}
            onEnter={() => {
              this.inputRef.current?.focus();
            }}
            onClose={() => {
              console.log('onClose Drop');

              this.setState({ anchorEl: null });
            }}
            onBackdropClick={() => {
              console.log('backclick Drop');

              this.setState({ anchorEl: null });
            }}
            transitionDuration={0}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}>
            <Textbox
              readOnly
              leftIcon='search'
              wrapperClass='filter-modal__textbox u-w-full'
              value={searchValue}
              placeholder='店舗名で検索'
              onClick={(e) => {
                this.setState({ anchorEl: e.currentTarget });
              }}
              data-testid-e2e='storeSelectModal-openSearchTextBox'
              data-testid='openSearchTextBox'
            />
          </Dropdown>
        </div>
        <div
          className='filter-modal__drilldown'
          style={{
            width: '100%',
            maxHeight: `calc(100svh - 285px - ${errorMessageHeight}px)`,
          }}>
          {/* 1階層目 */}
          <div className='filter-modal__drilldown-item' data-testid='filter-store-areadept1-content'>
            <div
              data-testid='filter-store-areadept1-head-title'
              data-testid-e2e='filterStoreSelectModal-areadept1Title'
              className='filter-modal__header-title'>
              部門1 ({_.map(this.state.isAreaDept1Checked, (data) => data).filter((a) => a).length}
              件)
            </div>
            <div className='filter-modal__scroll-area'>
              <ul className='list'>
                {this.state.displayedOnAreaDept1List &&
                  this.state.displayedOnAreaDept1List.map((areadept1Info) => (
                    <li
                      key={areadept1Info.code}
                      className={`list__item-link ${
                        areadept1Info.isActive && 'list__item-link--active'
                      } list__item-link--has-right-icon list__item-link--has-left-icon`}
                      data-testid-e2e='filterStoreSelectModal-areadept1List'
                      data-testid='filter-store-areadept1-store-list'>
                      <Checkbox
                        aria-label={'bc_' + areadept1Info.code}
                        className='list__left-checkbox'
                        name='example-checkbox'
                        // Code Smell対応
                        // onChange={(e) => {
                        onChange={() => {
                          this.changeTargetStoresOnareadept(areadept1Info.index, 1);
                        }}
                        checked={this.state.isAreaDept1Checked[areadept1Info.index]}
                        isIndeterminate={this.isIndeterminateByIndex(areadept1Info.index)}
                        value={areadept1Info.code}
                      />
                      <Link
                        to='#'
                        // Code Smell対応
                        // onChange={(e) => {
                        onClick={() => {
                          this.changeActiveareadept(areadept1Info.index, 1);
                        }}>
                        {areadept1Info.name}
                      </Link>
                      <Icon className='list__right-icon'>keyboard_arrow_right</Icon>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
          {/* 2階層目 */}
          <div className='filter-modal__drilldown-item' data-testid='filter-store-areadept2-content'>
            <div
              data-testid='filter-store-areadept2-head-title'
              data-testid-e2e='filterStoreSelectModal-areadept2Title'
              className='filter-modal__header-title'>
              部門2 ({_.map(this.state.isAreaDept2Checked, (data) => data).filter((a) => a).length}
              件)
            </div>
            <div className='filter-modal__scroll-area'>
              <ul className='list'>
                {this.state.displayedOnAreaDept2List &&
                  this.state.displayedOnAreaDept2List.map((areadept2Info) => (
                    <li
                      key={areadept2Info.code}
                      className={`list__item-link ${
                        areadept2Info.isActive && 'list__item-link--active'
                      } list__item-link--has-right-icon list__item-link--has-left-icon`}
                      data-testid-e2e='filterStoreSelectModal-areadept2List'
                      data-testid='filter-store-areadept2-store-list'>
                      <Checkbox
                        aria-label={'bc_' + areadept2Info.code}
                        className='list__left-checkbox'
                        name='example-checkbox'
                        // Code Smell対応
                        // onChange={(e) => {
                        onChange={() => {
                          this.changeTargetStoresOnareadept(areadept2Info.index, 2);
                        }}
                        checked={this.state.isAreaDept2Checked[areadept2Info.index]}
                        isIndeterminate={this.isIndeterminateByIndex(areadept2Info.index)}
                        value={areadept2Info.code}
                      />
                      <Link
                        to='#'
                        // Code Smell対応
                        // onChange={(e) => {
                        onClick={() => {
                          this.changeActiveareadept(areadept2Info.index, 2);
                        }}>
                        {areadept2Info.name}
                      </Link>
                      <Icon className='list__right-icon'>keyboard_arrow_right</Icon>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
          {/* 3階層目 */}
          <div className='filter-modal__drilldown-item' data-testid='filter-store-areadept3-content'>
            <div
              data-testid='filter-store-areadept3-head-title'
              data-testid-e2e='filterStoreSelectModal-areadept3Title'
              className='filter-modal__header-title'>
              部門3 ({_.map(this.state.isAreaDept3Checked, (data) => data).filter((a) => a).length}
              件)
            </div>
            <div className='filter-modal__scroll-area'>
              <ul className='list'>
                {this.state.displayedOnAreaDept3List &&
                  this.state.displayedOnAreaDept3List.map((areadept3Info) => (
                    <li
                      key={areadept3Info.code}
                      className={`list__item-link ${
                        areadept3Info.isActive && 'list__item-link--active'
                      } list__item-link--has-right-icon list__item-link--has-left-icon`}
                      data-testid-e2e='filterStoreSelectModal-areadept3List'
                      data-testid='filter-store-areadept3-store-list'>
                      <Checkbox
                        aria-label={'bc_' + areadept3Info.code}
                        className='list__left-checkbox'
                        name='example-checkbox'
                        // Code Smell対応
                        // onChange={(e) => {
                        onChange={() => {
                          this.changeTargetStoresOnareadept(areadept3Info.index, 3);
                        }}
                        checked={this.state.isAreaDept3Checked[areadept3Info.index]}
                        isIndeterminate={this.isIndeterminateByIndex(areadept3Info.index)}
                        value={areadept3Info.code}
                      />
                      <Link
                        to='#'
                        // Code Smell対応
                        // onChange={(e) => {
                        onClick={() => {
                          this.changeActiveareadept(areadept3Info.index, 3);
                        }}>
                        {areadept3Info.name}
                      </Link>
                      <Icon className='list__right-icon'>keyboard_arrow_right</Icon>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
          {/* 4階層目 */}
          <div className='filter-modal__drilldown-item' data-testid='filter-store-areadept4-content'>
            <div
              data-testid='filter-store-areadept4-head-title'
              data-testid-e2e='filterStoreSelectModal-areadept4Title'
              className='filter-modal__header-title'>
              部門4 ({_.map(this.state.isAreaDept4Checked, (data) => data).filter((a) => a).length}
              件)
            </div>
            <div className='filter-modal__scroll-area'>
              <ul className='list'>
                {this.state.displayedOnAreaDept4List &&
                  this.state.displayedOnAreaDept4List.map((areadept4Info) => (
                    <li
                      key={areadept4Info.code}
                      className={`list__item-link ${
                        areadept4Info.isActive && 'list__item-link--active'
                      } list__item-link--has-right-icon list__item-link--has-left-icon`}
                      data-testid-e2e='filterStoreSelectModal-areadept4List'
                      data-testid='filter-store-areadept4-store-list'>
                      <Checkbox
                        aria-label={'bc_' + areadept4Info.code}
                        className='list__left-checkbox'
                        name='example-checkbox'
                        // Code Smell対応
                        // onChange={(e) => {
                        onChange={() => {
                          this.changeTargetStoresOnareadept(areadept4Info.index, 4);
                        }}
                        checked={this.state.isAreaDept4Checked[areadept4Info.index]}
                        isIndeterminate={this.isIndeterminateByIndex(areadept4Info.index)}
                        value={areadept4Info.code}
                      />
                      <Link
                        to='#'
                        // Code Smell対応
                        // onChange={(e) => {
                        onClick={() => {
                          this.changeActiveareadept(areadept4Info.index, 4);
                        }}>
                        {areadept4Info.name}
                      </Link>
                      <Icon className='list__right-icon'>keyboard_arrow_right</Icon>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
          {/* 5階層目 */}
          <div className='filter-modal__drilldown-item' data-testid='filter-store-areadept5-content'>
            <div
              data-testid='filter-store-areadept5-head-title'
              data-testid-e2e='filterStoreSelectModal-areadept5Title'
              className='filter-modal__header-title'>
              部門5 ({_.map(this.state.isAreaDept5Checked, (data) => data).filter((a) => a).length}
              件)
            </div>
            <div className='filter-modal__scroll-area'>
              <ul className='list'>
                {this.state.displayedOnAreaDept5List &&
                  this.state.displayedOnAreaDept5List.map((areadept5Info) => (
                    <li
                      key={areadept5Info.code}
                      className={`list__item-link ${
                        areadept5Info.isActive && 'list__item-link--active'
                      } list__item-link--has-right-icon list__item-link--has-left-icon`}
                      data-testid-e2e='filterStoreSelectModal-areadept5List'
                      data-testid='filter-store-areadept5-store-list'>
                      <Checkbox
                        aria-label={'bc_' + areadept5Info.code}
                        className='list__left-checkbox'
                        name='example-checkbox'
                        // Code Smell対応
                        // onChange={(e) => {
                        onChange={() => {
                          this.changeTargetStoresOnareadept(areadept5Info.index, 5);
                        }}
                        checked={this.state.isAreaDept5Checked[areadept5Info.index]}
                        isIndeterminate={this.isIndeterminateByIndex(areadept5Info.index)}
                        value={areadept5Info.code}
                      />
                      <Link
                        to='#'
                        // Code Smell対応
                        // onChange={(e) => {
                        onClick={() => {
                          this.changeActiveareadept(areadept5Info.index, 5);
                        }}>
                        {areadept5Info.name}
                      </Link>
                      <Icon className='list__right-icon'>keyboard_arrow_right</Icon>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
          {/* 6階層目(最下層) */}
          <div className='filter-modal__drilldown-item' data-testid='filter-store-agency-content'>
            <div
              data-testid='agency-head-title'
              data-testid-e2e='filterStoreSelectModal-agencyStoreTitle'
              className='filter-modal__header-title'>
              店舗 ({_.map(this.state.isStoreChecked, (data) => data).filter((a) => a).length}
              件)
            </div>
            <div className='filter-modal__scroll-area'>
              <ul className='list'>
                {this.state.displayedOnAgencyList &&
                  this.state.displayedOnAgencyList.map((agencyInfo, idx) => (
                    <li
                      key={`${agencyInfo.code}-${idx}`}
                      className='list__item-link list__item-link--has-left-icon'
                      data-testid-e2e='filterStoreSelectModal-agencyList'
                      data-testid='filter-store-agency-store-list'>
                      <Checkbox
                        aria-label={'ac_' + agencyInfo.code}
                        className='list__left-checkbox u-pointer-events-none'
                        name='example-checkbox'
                        // Code Smell対応
                        // onChange={(e) => {
                        onChange={() => {
                          this.changeTargetStoresOnareadept(agencyInfo.index, 6);
                        }}
                        checked={this.state.isStoreChecked[agencyInfo.index]}
                        isIndeterminate={false}
                        value={agencyInfo.code}
                      />
                      <Link
                        to='#'
                        onClick={() => {
                          this.changeTargetStoresOnareadept(agencyInfo.index, 6);
                        }}>
                        {agencyInfo.name}
                      </Link>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </div>
      </>
    );
  }
}
